import * as React from 'react';

import Form from './partials/Form';

import Layout from '../../shared/Layout';

import NavigationProp from '../../../navigators/NavigationProp';

import * as routers from '../../../routers';

import {Params as StoryFormUpdateParams} from '../../../actions/story_forms/update';

import File from '../../../../domain/entities/File';
import StoryForm from '../../../../domain/forms/StoryForm';

export interface Params {}

export interface StateProps {
  navigation: NavigationProp;
  storyForm: StoryForm | null;
}

export interface DispatchProps {
  updateStoryForm: (params: StoryFormUpdateParams) => Promise<any>;
}

interface Props extends StateProps, DispatchProps {}

interface State {}

export default class New extends React.PureComponent<Props, State> {
  public render(): React.ReactNode {
    const {navigation, storyForm} = this.props;

    return (
      <Layout
        title={'表紙'}
        navigation={navigation}
        back={true}
        close={true}
        hideHeaderBottomBorder={true}>
        {storyForm && (
          <Form
            storyForm={storyForm}
            onChangeImage={this.handleChangeImage}
            onSubmit={this.handleSubmit}
            onRequestReset={this.handleRequestReset}
            onForwardToImageSelection={() => {}}
            onForwardToCharacterImageSelection={() => {}}
            onForwardToTextInput={() => {}}
          />
        )}
      </Layout>
    );
  }

  private handleRequestReset = () => {
    const {updateStoryForm} = this.props;
    updateStoryForm({
      coverImage: null,
      hasCoverImage: false,
      uploadedSelfCoverImage: false,
    });
  };

  private handleChangeImage = (coverImage: File) => {
    const {updateStoryForm} = this.props;
    updateStoryForm({coverImage, uploadedSelfCoverImage: true});
  };

  private handleSubmit = () => {
    const {navigation} = this.props;
    routers.linkToNewStoryFormImage(navigation, {});
  };
}
